import { object, string, number, array } from "yup";

const PriceSchema = object({
  price: number().min(0, "Invalid Price").notRequired(),
});

export default PriceSchema;
